import axios from "axios"
import {getStationCode} from "../../network/NetworkUtil";
import {convertSecondsToTimeFormat, formatAlias, getDateInMMDDYYYYWithOffset} from "../../util/Util";
import {
    ASSOCIATE_TAB_METRIC_KEY,
    ERROR_COUNT_METRIC,
    GLOBAL_METRIC_KEY,
    logErrorMetric,
    logOperationalMetric,
    MetricType,
    RSWS_ROUTE_LIST_METRIC
} from "../../util/MetricUtil";
import {TIMEOUTS} from "../../util/Constants";
import {Logger} from "../../util/Logger";
import {getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";

export function fetchAssociateMetrics(dispatcher, baseUrl, stationConfig) {
    getRouteInformation(dispatcher, baseUrl, stationConfig)
}

async function getRouteInformation(dispatcher, baseUrl, stationConfig) {
    try {
        const response = await getStationRoutes(baseUrl, stationConfig);
        const output = response.data.routes;
        dispatcher({ type: "RECEIVE_DATA", data: getStagersMetrics(output) });
    } catch (error) {
        Logger.error("Exception in AssociateNetworkAPI.getRouteInformation", error);
        logErrorMetric(getStationCode(), GLOBAL_METRIC_KEY, ERROR_COUNT_METRIC);
    }
}

async function getStationRoutes(baseUrl, stationConfig) {
    const startTime = Date.now();
    const stationCode = getStationCode();
    try {
        const api = axios.create({
            baseURL: baseUrl,
            timeout: TIMEOUTS.RSWS_GET_STATION_ROUTES_API_TIMEOUT
        });
        var response;
        if(stationConfig && stationConfig.authEnabled) {
            const requestBody = {
                "date": [getDateInMMDDYYYYWithOffset(0)]
            }
            const requestPayload = {
                resourcePath: "/apigw/route/station/" + getStationCode(),
                httpMethod: "get",
                processName: "routeStaging",
                requestParams: requestBody
            }
            response = await getAPIGatewayDataFromParent(requestPayload);
        } else {
            response = await api.get("/rsws/route/station/" + getStationCode() + "?date=" + getDateInMMDDYYYYWithOffset(0));
        }
        if (response && response.status === 200) {
            logOperationalMetric(startTime, stationCode, ASSOCIATE_TAB_METRIC_KEY, RSWS_ROUTE_LIST_METRIC, MetricType.SUCCESS);
            return response;
        } else {
            var error = {
                response : response
            }
            Logger.error("Exception in AssociateNetworkAPI.getStationRoutes" , error);
            logOperationalMetric(startTime, stationCode, ASSOCIATE_TAB_METRIC_KEY, RSWS_ROUTE_LIST_METRIC, MetricType.FAILED, error);
        }
    } catch (e) {
        Logger.error("Exception in AssociateNetworkAPI.getStationRoutes", e);
        logOperationalMetric(startTime, stationCode, ASSOCIATE_TAB_METRIC_KEY, RSWS_ROUTE_LIST_METRIC, MetricType.FAILED, e);
    }
    return null;
}

function getStagersMetrics(routes) {
    let allCarts = [];
    routes.forEach(route => {
        route.carts.forEach(cart => {
            if (cart.assignee && cart.status === "STAGED") {
                const index = cart.allAssignments.findIndex(assignment => assignment.alias === cart.assignee);
                if (index >= 0 && cart.allAssignments[index].endTime) {
                    allCarts.push({
                        loginId: cart.assignee,
                        associate: formatAlias(cart.assignee),
                        cart: cart.cartId,
                        location: route.stagingLocation,
                        startTime: cart.allAssignments[index].startTime,
                        endTime: cart.allAssignments[index].endTime
                    })
                }
            }
        })
    })

    const associateMap = allCarts.reduce((map, cart) => {
        if (map[cart.associate]) {
            if (cart.startTime < map[cart.associate].startTime) {
                map[cart.associate].startTime = cart.startTime;
            }
            if (cart.endTime > map[cart.associate].endTime) {
                map[cart.associate].endTime = cart.endTime;
                map[cart.associate].location = cart.location;
            }
            map[cart.associate].cartsHandled++;
        } else {
            map[cart.associate] = {
                loginId: cart.loginId,
                alias: cart.associate,
                cartsHandled: 1,
                location: cart.location,
                startTime: cart.startTime,
                endTime: cart.endTime
            }
        }
        return map;
    }, {});

    const associatePerformance = Object.values(associateMap).map(mapping => {
        return {
            loginId: mapping.loginId,
            alias: mapping.alias,
            location: mapping.location,
            cartsHandled: mapping.cartsHandled,
            cartsPerHour: getCartsPerHour(mapping.startTime, mapping.endTime, mapping.cartsHandled),
            hourSpent: getAssociateDuration(mapping.startTime, mapping.endTime),
            active: getAssociateActiveStatus(mapping.endTime),
            inActivePeriod: "...",
        }
    });
    return {
        associatePerformance
    }
}

function getCartsPerHour(startTime, endTime, cartsStaged) {
    const durationInMillis = endTime - startTime;
    if (!durationInMillis) {
        return 0;
    }
    return Math.ceil((cartsStaged * 60) / (Math.ceil(durationInMillis / 60000.0)));
}

function getAssociateDuration(startTime, endTime) {
    return convertSecondsToTimeFormat((endTime - startTime) / 1000);
}

// Active: if last scan was done in last 9 minutes
function getAssociateActiveStatus(endTime) {
    if (!endTime) {
        return "No";
    }
    const isActive = (Date.now() - 300000 - endTime) <= 240000;
    return isActive ? "Yes" : "No";
}



// WEBPACK FOOTER //
// ./src/components/stageassociate/network/AssociateNetworkAPI.js